<template>
  <div 
    :class="[`searchInput`, searchClass]">
    <b-input-group class="mt-3">
        <template #prepend>
            <b-input-group-text>
                <b-icon icon="search"></b-icon>
            </b-input-group-text>
        </template>

        
        <template #append>
            <b-input-group-text v-if="searchAppend.state">
                <span 
                    @click.prevent="searchAppend.action"
                    class="clearSearch">
                    <b-icon :icon="searchAppend.icon"></b-icon>
                </span>
            </b-input-group-text>
        </template>

        <b-form-input @input="emitsearch" :placeholder="placeholder"></b-form-input>
    </b-input-group>
  </div>
</template>

<script>
export default {
    props : {
        searchClass : {
            type : String,
            default : () => {
                return '';
            }
        },
        searchAppend : {
            type : Object,
            default : () => {
                return {
                    state : false,
                    icon  : 'x',
                    action: () => {}
                }
            }
        },
        placeholder: {
            type : String,
            default : () => {
                return 'Search';
            }
        }
    },
    methods : {
        /**
         * Emit text value from search box
         */
        emitsearch(text) {
            this.$emit('searching', text);
        }
    }
}
</script>

<style lang="scss">
@import "@/scss/partials/_colors.scss";

.searchInput {
    .form-control {
        &:focus {
            outline     : none;
            border-color: $lightgrey2;
        }
    } 
}
</style>